import createEnter from './providers/enter.js'
import createLoader from './providers/loader.js'
import createViewport from './providers/viewport.js'
import detectWebP from './utils/detect-webp.js'
import detectWindowLoad from './utils/detect-window-load.js'
import fetchContent from './utils/fetch-content.js'
import setupHeader from './sections/header.js'

const boot = () => detectWebP()
  .then(detectWindowLoad)
  .then(setupHeader)
  .then(fetchContent)
  .then(() => {
    const viewport = createViewport()

    createEnter()
    createLoader(viewport)
  })

boot()
